<template>
  <section class="step1">
    <div class="step1-inner">
      <div class="step1-titleWrap">
        <div class="sub-title">STEP.01</div>
        <h2 class="title">商品を絞り込む</h2>
      </div>
      <ul class="selectList">
        <li class="selectList-item">
          <RadioSection
            :analyticsPrefix="'birui'"
            :title="'商品カテゴリー'"
            :storeKey="'bigan_name'"
            :form="forms.bigan_names"
          ></RadioSection>
        </li>
      </ul>
    </div>
    <div class="step1-sticky-wrap">
      <div class="step1-inner">
        <ul class="selectList">
          <li class="selectList-item">
            <CheckboxSection
              :analyticsPrefix="'brand'"
              :title="'ブランド'"
              :storeKey="'brand_names'"
              :form="forms.brand_names"
            ></CheckboxSection>
          </li>

          <li class="selectList-item">
            <CheckboxSection
              :analyticsPrefix="'nayami'"
              :title="'肌悩み'"
              :storeKey="'worries_some'"
              :form="forms.worries_some"
            ></CheckboxSection>
          </li>
          <li class="selectList-item">
            <CheckboxSection
              :analyticsPrefix="'kakaku'"
              :title="'価格帯'"
              :storeKey="'price_range'"
              :form="forms.price_range"
            ></CheckboxSection>
          </li>
          <li class="selectList-item">
            <CheckboxSection
              :analyticsPrefix="'seibun'"
              :title="'主な有効成分'"
              :storeKey="'seibun'"
              :form="forms.seibun"
            ></CheckboxSection>
          </li>
          <li class="selectList-item">
            <CheckboxSection
              :analyticsPrefix="'free'"
              :title="'その他'"
              :storeKey="'kinou_search'"
              :form="forms.kinou_search"
            ></CheckboxSection>
          </li>
        </ul>
      </div>
      <next-button
        class="nextButton"
        :isActive="isCategorySelected"
        @clickButton="handleClickNext"
        >次のSTEPへ</next-button
      >
      <SearchIcon class="searchIcon" :number="searchNumber" />
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import CheckboxSection from "./CheckboxSection.vue";
import RadioSection from "./RadioSection.vue";
import SearchIcon from "../../model/common/SearchIcon.vue";
import NextButton from "../../model/common/NextButton.vue";
export default {
  name: "step1",
  components: { CheckboxSection, RadioSection, SearchIcon, NextButton },
  props: {
    searchNumber: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters("jsonData", ["forms"]),
    ...mapGetters("selectedFormIds", ["isCategorySelected"]),
  },
  methods: {
    handleClickNext() {
      if (!this.isCategorySelected) return;
      this.$router.push("/select");
    },
  },
};
</script>
<style lang="scss">
.step1 {
  width: 100%;
  padding-bottom: 40px;
  position: relative;

  .step1-inner {
    width: 100%;
    max-width: 960+20 * 2px;
    padding: 0 20px;
    margin: 0 auto;
  }

  .step1-titleWrap {
    text-align: center;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 2.4px;
  }

  .sub-title {
    font-family: Oswald;
    color: $main-red;
    font-size: 16px;
    letter-spacing: 1.2px;
  }

  .selectList {
    margin-top: 20px;
  }

  .selectList-item {
    & + .selectList-item {
      margin-top: 32px;
    }
  }
  .searchIcon {
    margin-top: -80px;
    margin-left: auto;
    margin-right: 20px;
    position: sticky;
    right: 0;
    bottom: 30px;
  }
  .nextButton {
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    position: sticky;
    left: 0;
    bottom: 40px;
  }

  @include media() {
    margin-top: vw(30);
    padding-bottom: vw(40);

    .step1-inner {
      max-width: none;
      padding: 0 20px;
    }

    .title {
      font-size: vw(16);
    }

    .sub-title {
      font-size: vw(14);
    }

    .selectList {
      margin-top: vw(30);
    }

    .selectList-item {
      & + .selectList-item {
        margin-top: vw(40);
      }
    }

    .searchIcon {
      bottom: vw(45);
      margin-top: vw(-90);
      margin-right: vw(15);
    }

    .nextButton {
      bottom: vw(20);
      margin-top: vw(60);
    }
  }
}
</style>
